// Generated by Melange

import * as StaticAsset from "../../../../../packages/util/lib/StaticAsset.js";
import * as JsxRuntime from "react/jsx-runtime";

function DocsPost(Props) {
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("p", {
        children: "Home / Касса",
        className: "paragraph-small text-gray-landing mt-10 lg:mt-16"
      }),
      JsxRuntime.jsx("h3", {
        children: "Financial reports",
        className: "h4 lg:h3 text-black-landing mt-4"
      }),
      JsxRuntime.jsx("p", {
        children: "Learn about using the Dashboard to operate your Buhta account.",
        className: "paragraph text-black-landing mt-2 lg:mt-1"
      }),
      JsxRuntime.jsx("p", {
        children: "The Buhta Dashboard offers a user interface for you to operate and configure your Stripe account. You can use it to manage payments and refunds, respond to disputes, monitor your integration, and more.\n\nHome provides information about the activity on your account. A wide range of analytics and real-time charts provide insight into the performance of your business. Home also shows recent activity that may require you to take action, such as unanswered disputes or identity verifications. Learn more.",
        className: "paragraph text-black-landing mt-10 lg:mt-16 whitespace-pre-line"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("img", {
            className: "shrink-0",
            src: StaticAsset.src("/static/icons/question.svg")
          }),
          JsxRuntime.jsx("p", {
            children: "In response to the elevated disputes being faced by many merchants in the travel & entertainment industries due to COVID-19, Visa and Mastercard have issued guidelines on how to resolve disputes related to goods and services cancelled directly due to a government order or prohibition. If the disputes your business is receiving fall in this category, please proceed to this guide for guidance on how to submit dispute evidence before the submission due date.",
            className: "paragraph-small text-gray-landing ml-4"
          })
        ],
        className: "bg-bg rounded-sm flex p-4 mt-6 lg:mt-10"
      }),
      JsxRuntime.jsx("img", {
        className: "mt-6 lg:mt-10",
        alt: "dashboard",
        src: StaticAsset.src("/static/images/dashboard.png")
      }),
      JsxRuntime.jsx("p", {
        children: "The Buhta Dashboard",
        className: "caption text-gray-landing mt-2"
      }),
      JsxRuntime.jsx("h6", {
        children: "Creating reports and searches",
        className: "h6 text-black-landing mt-6 lg:mt-10"
      }),
      JsxRuntime.jsx("p", {
        children: "All of your transactional data can be filtered and exported as reports in CSV format. You can also download a monthly report or QuickBooks-formatted export from your account’s business settings.\n\nYou can use the Dashboard search to find specific information using search terms and operators (e.g., find a specific payment using the customer’s email address or the last four digits of their card number) to narrow down the number of results.\n\nFor more advanced searches and reporting, Stripe Sigma makes all of your data available as an interactive SQL environment in the Dashboard. You can write queries to generate customized reports without needing to use additional reporting tools.",
        className: "paragraph text-black-landing mt-4 whitespace-pre-line"
      }),
      JsxRuntime.jsx("h6", {
        children: "Browser compatibility",
        className: "h6 text-black-landing mt-6 lg:mt-10"
      }),
      JsxRuntime.jsxs("ul", {
        children: [
          JsxRuntime.jsx("li", {
            children: "Chrome versions greater than 49",
            className: "paragraph text-black-landing"
          }),
          JsxRuntime.jsx("li", {
            children: "The last two versions of Firefox, Safari, and Edge",
            className: "paragraph text-black-landing"
          }),
          JsxRuntime.jsx("li", {
            children: "The last two versions of mobile Safari on iOS",
            className: "paragraph text-black-landing"
          }),
          JsxRuntime.jsx("li", {
            children: "Internet Explorer 11",
            className: "paragraph text-black-landing"
          })
        ],
        className: "mt-4 list-disc list-inside"
      }),
      JsxRuntime.jsx("p", {
        children: "По вопросам сотрудничества и партнерства пишите на hello@buhta.com",
        className: "paragraph-small text-gray-landing mt-6 lg:mt-10"
      }),
      JsxRuntime.jsx("hr", {
        className: "text-divider mt-10"
      }),
      JsxRuntime.jsx("h6", {
        children: "See also",
        className: "h6 text-black-landing mt-10"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("p", {
                children: "Buhta Atlas",
                className: "paragraph-medium text-primary-variant"
              }),
              JsxRuntime.jsx("p", {
                children: "Use Stripe Atlas to incorporate your startup and issue stock to founders.",
                className: "paragraph-small text-gray-landing"
              })
            ],
            className: "lg:w-68 bg-bg px-4 py-3 rounded"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("p", {
                children: "Financial services",
                className: "paragraph-medium text-primary-variant"
              }),
              JsxRuntime.jsx("p", {
                children: "Get help with financial services, like corporate cards and loans.",
                className: "paragraph-small text-gray-landing"
              })
            ],
            className: "lg:w-68 bg-bg px-4 py-3 rounded-sm mt-6 lg:mt-0"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("p", {
                children: "Buhta Dashboard",
                className: "paragraph-medium text-primary-variant"
              }),
              JsxRuntime.jsx("p", {
                children: "Learn to manage disputes to protect your business from fines.",
                className: "paragraph-small text-gray-landing"
              })
            ],
            className: "lg:w-68 bg-bg px-4 py-3 rounded-sm mt-6 lg:mt-0"
          })
        ],
        className: "flex justify-between mt-4 lg:mb-6 flex-wrap"
      })
    ]
  });
}

const make = DocsPost;

export {
  make,
}
/* react/jsx-runtime Not a pure module */
